export default __webpack_public_path__ + "static/media/pain-during-sex.7a92aee8.png";